var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDoorLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 511.84 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 286",
  d: "M511.84 17.711v476.578A17.736 17.736 0 01494.129 512H243.73a17.736 17.736 0 01-17.711-17.711V17.711A17.731 17.731 0 01243.73 0h250.4a17.731 17.731 0 0117.71 17.711zm0 0",
  fill: "#b4d2d7"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 287",
  d: "M511.84 17.711v476.578A17.736 17.736 0 01494.129 512h-124.75V0h124.75a17.731 17.731 0 0117.711 17.711zm0 0",
  fill: "#9cbcbf"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 288",
  d: "M423.93 150.43a57.11 57.11 0 01-54.551 56.992q-1.242.059-2.5.059H17.34A17.354 17.354 0 010 190.148v-79.437a17.354 17.354 0 0117.34-17.332h349.539q1.26 0 2.5.063a57.1 57.1 0 0154.551 56.988zm0 0",
  fill: "#e1ebf0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 289",
  d: "M414.426 317.523a45.563 45.563 0 01-30.5 42.941v42.879a15 15 0 01-14.551 14.992c-.148.008-.3.008-.449.008a15 15 0 01-15-15v-42.878a45.486 45.486 0 0115-88.43h.449a45.558 45.558 0 0145.051 45.488zm0 0",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 290",
  d: "M414.426 317.523a45.563 45.563 0 01-30.5 42.941v42.879a15 15 0 01-14.551 14.992v-146.3a45.558 45.558 0 0145.051 45.488zm0 0",
  fill: "#e1ebf0"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 291",
  d: "M423.93 150.43a57.11 57.11 0 01-54.551 56.992V93.441a57.1 57.1 0 0154.551 56.989zm0 0",
  fill: "#b4d2d7"
})));
export default SvgDoorLock;